import { render } from "./BackgroundAnimate.vue?vue&type=template&id=1a75f5f5&scoped=true"
import script from "./BackgroundAnimate.vue?vue&type=script&lang=js"
export * from "./BackgroundAnimate.vue?vue&type=script&lang=js"

import "./BackgroundAnimate.vue?vue&type=style&index=0&id=1a75f5f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a75f5f5"]])

export default __exports__